<template>
  <v-container>
    <v-snackbar
      v-model="notificationSnackbar"
      v-for="notification in notifications"
      :key="notification.id"
      :color="notification.type"
    >
      {{notification.message}}
      <v-btn text @click="notificationSnackbar = false">Chiudi</v-btn>
    </v-snackbar>
  </v-container>
</template>

<script>
import { mapState, mapActions } from "vuex";
export default {
  data() {
    return {
      notificationSnackbar: true
    };
  },
  computed: mapState("notification", ["notifications"]),
  methods: {
    ...mapActions("notification", ["reset"])
  },
  mounted: function() {
    this.reset();
  },
  watch: {
    notifications: function() {
      this.notificationSnackbar = true;
    },
    notificationSnackbar: function() {
        if(!this.notificationSnackbar){
            this.reset();
        }
    }
  }
};
</script>
<style>
</style>